<section class="uk-section uk-margin-large-bottom uk-padding-remove-bottom step-buy">
    <div class="uk-container">
        <div class="uk-grid-collapse uk-child-width-1-2@m" uk-grid>
            <div class="uk-flex uk-flex-middle uk-flex-center">
                <header class="uk-text-center uk-margin-bottom">
                    <h3 class="uk-heading-small uk-margin-small-bottom uk-position-relative uk-text-bold step-buy.head">TISCO INSURE</h3>
                    <p class="uk-h4 uk-margin-remove uk-h2">ซื้อประกันง่ายๆ<br class="break-line">เพียง 3 ขั้นตอน</p>
                </header>
            </div>
            <div class="uk-grid-collapse uk-child-width-1-2@s step-buy.box" uk-grid>
                <div class="uk-padding uk-border-rounded uk-light uk-position-relative box-item" step="1">
                    <h4 class="uk-text-center uk-margin-small-bottom uk-text-bold">เลือกประเภทประกัน</h4>
                    <p class="uk-margin-remove">เลือกประเภทประกันที่ตรง กับความต้องการของคุณ</p>
                </div>
                <div class="uk-padding uk-border-rounded uk-light uk-position-relative box-item" step="2">
                    <h4 class="uk-text-center uk-margin-small-bottom uk-position-relative uk-text-bold">ใส่ข้อมูลเบื้องต้น</h4>
                    <p class="uk-margin-remove">กรอกข้อมูลและตอบคำถาม ตามประเภทประกันภัยที่คุณเลือก</p>
                </div>
                <div class="uk-padding uk-border-rounded uk-light uk-position-relative box-item" step="3">
                    <h4 class="uk-text-center uk-margin-small-bottom uk-position-relative uk-text-bold">รับความคุ้มครอง</h4>
                    <p class="uk-margin-remove">รับความคุ้มครองทันที เมื่อตรงตามเงื่อนไขและ ชำระเงิน เสร็จสมบูรณ์</p>
                </div>
                <div class="uk-padding uk-border-rounded uk-position-relative uk-text-center box-item --cta-buy +extra-shadow">
                    <h4 class="uk-h3 uk-margin-medium-bottom uk-position-relative uk-text-bold">ชัวร์! กับประกันที่ ใช่</h4>
                    <a routerLink="/buy-insurance" class="uk-button uk-button-primary uk-border-rounded">ซื้อประกันออนไลน์</a>
                </div> 
            </div>
        </div>
    </div>
</section>